"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cavagnolo": {
    "5ad1e695": [{
      "hkey": "b0390d27",
      "slug": "cavagnolo",
      "name": "Cavagnolo",
      "primary": true,
      "skipSearch": false
    }],
    "98dab63f": [{
      "hkey": "b0390d27",
      "slug": "cavagnolo",
      "name": "Cavagnolo",
      "primary": true,
      "skipSearch": false
    }],
    "9ac4cbd4": [{
      "hkey": "b0390d27",
      "slug": "cavagnolo",
      "name": "Cavagnolo",
      "primary": true,
      "skipSearch": false
    }],
    "a0160d71": [{
      "hkey": "b0390d27",
      "slug": "cavagnolo",
      "name": "Cavagnolo",
      "primary": true,
      "skipSearch": false
    }],
    "a56e82d2": [{
      "hkey": "b0390d27",
      "slug": "cavagnolo",
      "name": "Cavagnolo",
      "primary": true,
      "skipSearch": false
    }],
    "are": [{
      "hkey": "b0390d27",
      "slug": "cavagnolo",
      "name": "Cavagnolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c55cf3e1": [{
      "hkey": "b0390d27",
      "slug": "cavagnolo",
      "name": "Cavagnolo",
      "primary": true,
      "skipSearch": false
    }],
    "casa-mosso": [{
      "hkey": "b0390d27",
      "slug": "cavagnolo",
      "name": "Cavagnolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ea38de5f": [{
      "hkey": "b0390d27",
      "slug": "cavagnolo",
      "name": "Cavagnolo",
      "primary": true,
      "skipSearch": false
    }],
    "ed8cf59f": [{
      "hkey": "b0390d27",
      "slug": "cavagnolo",
      "name": "Cavagnolo",
      "primary": true,
      "skipSearch": false
    }],
    "maiaris": [{
      "hkey": "b0390d27",
      "slug": "cavagnolo",
      "name": "Cavagnolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "masseria": [{
      "hkey": "b0390d27",
      "slug": "cavagnolo",
      "name": "Cavagnolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "valentino": [{
      "hkey": "b0390d27",
      "slug": "cavagnolo",
      "name": "Cavagnolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "valle-gobbi": [{
      "hkey": "b0390d27",
      "slug": "cavagnolo",
      "name": "Cavagnolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "valminore": [{
      "hkey": "b0390d27",
      "slug": "cavagnolo",
      "name": "Cavagnolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "villa": [{
      "hkey": "b0390d27",
      "slug": "cavagnolo",
      "name": "Cavagnolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "93ff5053": [{
      "hkey": "c01ba927",
      "slug": "are-casa-ostino",
      "name": "Are-Casa Ostino",
      "primary": true,
      "skipSearch": false
    }],
    "casa-ostino": [{
      "hkey": "c01ba927",
      "slug": "are-casa-ostino",
      "name": "Are-Casa Ostino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e49c900a": [{
      "hkey": "4a6fe43a",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "pomaretto": [{
      "hkey": "4a6fe43a",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;